import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineModalFilterService } from '../../../services/timeline-modal-filter.service';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@Component({
  selector: 'wilson-display-qualified-working-time-checkbox',
  imports: [CommonModule, FormsModule, TranslateModule, NzCheckboxModule],
  templateUrl: './display-qualified-working-time-checkbox.component.html',
  styleUrls: ['./display-qualified-working-time-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayQualifiedWorkingTimeCheckboxComponent implements OnInit {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  ngOnInit(): void {
    this.qualifiedWorkingTimeStaffChanged(true);
  }

  qualifiedWorkingTimeStaffChanged(showOnlyQualifiedWorkingTimeStaff: boolean) {
    this.timelineModalFilterService.qualifiedWorkingTimeStaffChanged(
      showOnlyQualifiedWorkingTimeStaff,
    );

    this.cdRef.detectChanges();
  }
}
